export default (value) => {
  if (!value) return ''
  if (value === 'Closed') return 'Closed'

  return value.slice(0, -3)
}
